import { render, staticRenderFns } from "./UsersGrid.vue?vue&type=template&id=3cf4cad8"
import script from "./UsersGrid.vue?vue&type=script&lang=js"
export * from "./UsersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf4cad8')) {
      api.createRecord('3cf4cad8', component.options)
    } else {
      api.reload('3cf4cad8', component.options)
    }
    module.hot.accept("./UsersGrid.vue?vue&type=template&id=3cf4cad8", function () {
      api.rerender('3cf4cad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/UsersGrid.vue"
export default component.exports